import PortalAppService from "../../../application/platform/portal-app-service";
import { ACTION_TYPES, useGovernmentProjectsDispatch } from "./government-projects-context";
import { IListGovernmentProjectsRequest } from "../../../model/base/request/list-government-projects-request";

export const useGovernmentProjectsController = () => {
    const governmentProjectsDispatch = useGovernmentProjectsDispatch();

    async function loadData(request: IListGovernmentProjectsRequest) {
        try {
            // Limpa os dados antes de carregar novos
            governmentProjectsDispatch({
                type: ACTION_TYPES.CLEAR_GOVERNMENT_PROJECTS,
            });
            const result = await PortalAppService.requestGovernmentProjects(request);
            governmentProjectsDispatch({
                type: ACTION_TYPES.SET_GOVERNMENT_PROJECTS,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    async function loadDetail(id: number) {
        try {
            const result = await PortalAppService.requestGovernmentProjectDetail(id);
            governmentProjectsDispatch({
                type: ACTION_TYPES.SET_PROJECT_DETAIL,
                payload: result,
            });
        } catch (error) {
            console.log(error);
        }
    }

    return {
        loadData,
        loadDetail
    };
};
